import { useTheme } from 'hooks/theme';
import type { FC } from 'react';
import type { ScSpinnerProps } from './styled';
import { ScSpinner } from './styled';

export const Spinner: FC<ScSpinnerProps> = (props) => {
  const { preloaderSpinnerAnimation: PreloaderSpinnerAnimation } = useTheme();

  return (
    <ScSpinner {...props}>
      <PreloaderSpinnerAnimation />
    </ScSpinner>
  );
};
